import React, { useState, useContext, useEffect } from 'react'
import logo from './../assets/logo.png'
import { Link } from "react-router-dom";
import { MdOutlineSearch } from "react-icons/md";
import HeaderItem from './HeaderItem.jsx';
import { TbDotsVertical } from "react-icons/tb";
import { BsCalendarDay } from "react-icons/bs";
import { FaTheaterMasks } from "react-icons/fa";
import { FaMusic } from "react-icons/fa6";
import { IoMdHome } from "react-icons/io";
import { MdTv } from "react-icons/md";
import Button, { LinkButton } from './Button.jsx';
import { MeuContexto } from "../App"
import person from '../assets/person.png'; // Placeholder for user avatar

function Header() {
  const [toggle, setToggle] = useState(false)
  const { logado, setlogado, username } = useContext(MeuContexto)

  const menu = [
    { name: 'Início', icon: IoMdHome, link: '/' },
    { name: 'Procurar', icon: MdOutlineSearch, link: '/Lives/Procurar' },
    { name: 'Agenda', icon: BsCalendarDay, link: '/Agenda' },
    { name: 'Teatro', icon: FaTheaterMasks, link: '/Lives/Teatro' },
    { name: 'Música', icon: FaMusic, link: '/Lives/Música' },
    { name: 'Shows', icon: MdTv, link: '/Lives/Shows' },
  ]

  function _sair() {
    setlogado(false)
  }

  // Close mobile menu when clicking outside
  useEffect(() => {
    function handleClickOutside() {
      if (toggle) {
        setToggle(false)
      }
    }

    if (toggle) {
      document.addEventListener('click', handleClickOutside)
      return () => document.removeEventListener('click', handleClickOutside)
    }
  }, [toggle])

  return (
    <header 
      className='bg-background/80 backdrop-blur-lg border-b border-border sticky top-0 z-50'
      role="banner"
    >
      <div className='flex items-center justify-between p-4 max-w-screen-2xl mx-auto'>
        {/* Logo and Navigation Container */}
        <div className='flex gap-8 items-center flex-1'>
          {/* Logo */}
          <Link 
            to="/" 
            className='flex-shrink-0 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background rounded-lg' 

            aria-label="SMIZE TV - Home"
          >
            <img 
              src={logo} 
              alt="SMIZE TV Logo" 
              className='w-[120px] md:w-[150px] object-contain transition-transform duration-300 hover:scale-105' 
            />
          </Link>
          
          {/* Desktop Navigation */}
          <nav 
            className='hidden lg:flex items-center gap-1' 
            role="navigation" 
            aria-label="Main menu"
          >
            {menu.map((item, index) => (
              <Link 
                key={index} 
                to={item.link} 

                className='px-2 py-2 rounded-lg text-text-subtle hover:text-text hover:bg-surface transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background'
                aria-label={item.name}
              >
                <HeaderItem name={item.name} Icon={item.icon} />
              </Link>
            ))}
          </nav>
          
          {/* Mobile Navigation Trigger */}
          <nav 
            className='flex items-center gap-1 lg:hidden' 
            role="navigation" 
            aria-label="Mobile menu"
          >
            {/* Search Icon */}
            <Link  
              to="/Lives/Procurar"

              className='p-3 rounded-full text-text-subtle hover:text-text hover:bg-surface transition-colors duration-200'
              aria-label="Search"
            >
              <MdOutlineSearch className="h-6 w-6" />
            </Link>
            
            {/* Mobile dropdown menu button */}
            <button
              onClick={(e) => {
                e.stopPropagation()
                setToggle(!toggle)
              }}
              className='p-3 rounded-full text-text-subtle hover:text-text hover:bg-surface transition-colors duration-200'
              aria-expanded={toggle}
              aria-label="Open main menu"
              aria-haspopup="true"
            >
              <TbDotsVertical className="h-6 w-6"/>
            </button>
          </nav>

           {/* Mobile Menu Panel */}
           {toggle && (
            <>
              <div 
                className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden animate-fade-in"
                onClick={() => setToggle(false)}
                aria-hidden="true"
              />
              <div 
                className='fixed top-0 right-0 h-full w-72 bg-surface border-l border-border shadow-2xl p-4 z-50 flex flex-col gap-2 animate-slide-in-left  lg:hidden'
                role="menu"
                aria-label="Main menu"
                onClick={(e) => e.stopPropagation()}
              >
                <h2 className="font-display text-xl font-semibold text-text">Menu</h2>
               
                <div className='bg-surface rounded-lg p-2'>
                   {menu.map((item, index) => (
                  <Link 
                    key={index}
                    to={item.link} 
                    onClick={() => { 
                      setToggle(false);
                    }}
                    className='flex items-center gap-4 px-4 py-3 text-text-subtle hover:text-text hover:bg-background rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary'
                    role="menuitem"
                  >
                    <item.icon className="h-5 w-5" />
                    <span className="font-semibold">{item.name}</span>
                  </Link>
                ))}
               </div>
              </div>
            </>
          )}

        </div>

        {/* Authentication Section */}
        <div className='flex items-center gap-2 flex-shrink-0'>
          {(!logado) ? (
            <div className='hidden sm:flex items-center gap-2'>
              <Link to="/SignIn">
                <Button variant="ghost">
                  Entrar
                </Button>
              </Link>
              <Link to="/SignUp">
                <Button variant="primary">
                  Criar Conta
                </Button>
              </Link>
            </div>
          ) : (
            <div className='flex items-center gap-2'>
              {/* Desktop User Info */}
              <div className="hidden sm:flex flex-col items-end">
              <Link to="/Usuario" className="flex-shrink-0">
                <p className="font-semibold text-regular text-text">{username}</p>
                </Link>
                <LinkButton onClick={_sair} className=" text-xs text-text-subtle">
                <p className="text-regular ">Sair</p>
                </LinkButton>
              </div>

               {/* User Avatar 
              <Link to="/Usuario" className="flex-shrink-0">
                <img 
                  src={person} 
                  alt={`Profile for ${username}`} 
                  className='h-10 w-10 rounded-full object-cover border-2 border-border hover:border-primary transition-colors duration-200'
                />
              </Link>*/}
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header